import { DailyReports, SummaryReports } from '../models/reports.models';

export const REPORTS_STORE_KEY = 'reports';

export interface IDailyReportState {
  dailyReports: DailyReports[];
  paginatedDailyReports: DailyReports[];
  filteredDailyReportsTotalCount: number;
  paginatedSummaryReports: SummaryReports[];
  filteredSummaryReportsTotalCount: number;
  dailyReportsQuery: string;
  summaryReportsQuery: string;
  isLoading: boolean;
}

export const initialState: IDailyReportState = {
  dailyReports: [],
  paginatedDailyReports: [],
  filteredDailyReportsTotalCount: 0,
  paginatedSummaryReports: [],
  filteredSummaryReportsTotalCount: 0,
  dailyReportsQuery: '',
  summaryReportsQuery: '',
  isLoading: false,
};
